import { useContext } from "react";

import { OperationalModulePickerContext } from "./operationalModulePicker.definition";

export const useOperationalModulePicker = () => {
  const context = useContext(OperationalModulePickerContext);
  if (!context) {
    throw new Error(
      "useOperationalModulePicker must be used within OperationalModulePickerProvider",
    );
  }
  return context;
};
